import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ChronogramSVG } from 'images/chronogram.svg';

const ChronogramIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ChronogramSVG/>
    </div>
  );
};

export { ChronogramIcon };
